module.exports = __webpack_public_path__ + "img/s4Model5.d6b1983f.svg";